import { Bar } from '@ant-design/plots';
import {useAntCharts} from "../../../charts/ant/useAntCharts";


const SectorWaterfall = ({ sectors }) => {
  const { axisConfig } = useAntCharts();
  // Helper function to calculate the cumulative values
  const prepareData = (sectors) => {
    let cumulative = 0;
    return sectors.map((sector) => {
      const start = cumulative;
      cumulative += sector.y * 100; // Update cumulative percentage
      return {
        x: sector.x,
        start,
        end: cumulative,
        value: sector.y * 100,
      };
    });
  };

  const data = prepareData(sectors);

  const config = {
    data,
    autoFit: true,
    xField: 'x',
    yField: ['end', 'start'],
    color: 'l(270) 0:#cfe0fc 1:#0047ba', // Linear gradient from light to dark blue
    columnStyle: {
      shadowColor: 'rgba(0, 0, 0, 0.2)', // Slight box shadow to make bars pop
      shadowBlur: 6,
      shadowOffsetX: 2,
      shadowOffsetY: 2,
      cursor: 'pointer', // Makes bars more interactive
    },
    axis: {
      x: {
        ...axisConfig,
      },
      y: {
        ...axisConfig,
        max: 100,
      },
    },
  };

  return <Bar {...config} />;
};

export default SectorWaterfall;
